import { useParams } from "react-router-dom";
import { useGetSellerAvailablePoint, useGetSellerDetail } from "../../../hooks/seller";

const useDetail = () => {
  const { id } = useParams();

  const { data: dataDetail, loading: loadingDetail, refetch } = useGetSellerDetail({ id });
  const { data: dataAvailablePoint, loading: loadingAvailablePoint } = useGetSellerAvailablePoint({ id });

  return {
    sellerDetail: { ...dataDetail, ...dataAvailablePoint },
    loading: loadingDetail || loadingAvailablePoint,
    refetch,
  };
};

export default useDetail;
